import { BITSKI_API_V2 } from '$lib/constants';
import { getUsernameAndTestAppId } from '$lib/url';
import { fetchJson, getAccounts, getResponseErrorCode, withDependencies } from '$lib/api';
import { error } from '@sveltejs/kit';
import type { LayoutLoad } from './$types';
import type { Profile } from '$lib/interfaces';

export const load: LayoutLoad = async ({ params, fetch, parent }) => {
  return withDependencies(async () => {
    const [username, testAppId] = getUsernameAndTestAppId(params.username);
    const isTestMode = !!testAppId;

    const { user } = await parent();
    const isCurrentUserProfile = user?.preferredUsername === username;

    try {
      const { profile } = await fetchJson<{ profile: Profile }>(
        fetch,
        `${BITSKI_API_V2}/profiles/${username}`,
      );
      let addresses: string[];

      if (params.address) {
        addresses = [params.address];
      } else if (isCurrentUserProfile) {
        addresses = await getAccounts(fetch);
      } else {
        addresses = profile?.connectedAccounts.map((account) => account.externalId);
      }

      return {
        isCurrentUserProfile,
        addresses,
        profile,
        username,
        isTestMode,
        testAppId,
      };
    } catch (e) {
      if (getResponseErrorCode(e) === 404) {
        console.warn('profile not found');
        throw error(404);
      }

      return {
        username,
        testAppId,
      };
    }
  });
};
